import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: ":schoolId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-levels" */ "./components"),
      import(
        /* webpackChunkName: "grade-levels" */ "./modules/GradeLevelsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      if (reducer) {
        injectReducer(store, {
          key: "gradeLevels",
          reducer,
        });
      }

      return component;
    })
  ),
});
